<style scoped>
  .current-name {
    color:#1976d2 !important;
  }
</style>
<template>
  <v-form
    ref="form"
    v-model="valid"
  >
    <v-row>
      <v-col class="pb-0">
        <anchor-text-field
          id="domain-form-name-input"
          required
          label="Name"
          hide-details=”auto”
          v-model="model.name"
          :rules="rules.name"
        />
      </v-col>
    </v-row>
    <div class="d-flex">
      <v-spacer />
      <anchor-form-buttons
        submit-text="save"
        :valid="valid"
        @submit="submit"
        @cancel="() => $emit('cancel')"
      />
    </div>
  </v-form>
</template>

<script>
/* eslint no-underscore-dangle: ["error", { "allow": ["_id"] }] */
import DOMAIN_MODEL from './resources/model';
import FORM_RULES from './resources/rules';


export default {
  name: 'AdminDomainsForm',
  data: () => ({
    model: DOMAIN_MODEL,
    rules: FORM_RULES,
    valid: false,
    loading: false,
  }),
  methods: {
    createDomain() {
      this.loading = true;
      const url = '/v1/domains';
      this.$requests.post(url, this.model)
        .then(() => {
          this.$toast.success('Domain successfully saved!', { timeout: 3000 });
          this.$emit('success');
        })
        .catch(() => {
          this.$toast.error('Unable to save domain...', { timeout: 3000 });
        })
        .then(() => {
          this.loading = false;
        });
    },
    submit() {
      if (!this.$refs.form.validate()) { return; }
      this.createDomain();
    },
    reset() {
      this.$refs.form.reset();
    },
  },
  mounted() {
    this.reset();
  },
};
</script>
